import React from 'react';
import StockContext from '../../../contexts/StocksContext'
import StatusContext from '../../../contexts/StatusContext'
import './stockstemplates.css'

import Stack from '@mui/material/Stack'
import EditIcon from '@mui/icons-material/Edit';
import {PushButton} from '../pushbutton/PushButton'
import { Delete} from "@mui/icons-material"


export const Symbols = () => {

  
  let {
    changeLanguageEnglish,

  } = React.useContext(StatusContext);

   let {
    onAddNewSymbols,
    newstockSymbols,
    setStockSymbols,
    selectedSymbolsIndex,
    handleSelectSynbols,
    handleDeleteSymbolsGroup,
    onSaveSymbols,
    setShowSymbolsDialog,
    setAddSymbolsGroup

  } = React.useContext(StockContext);

 const handleOnClick = (index) => {
   handleSelectSynbols(index)
 }

 const handleOnAdd = () => {
 
  setStockSymbols([])
  setAddSymbolsGroup(true)
  setShowSymbolsDialog(true)
  
 }

  return (
 
    <div > 
       <label style={{marginTop:'10px', marginBottom:'0px', fontWeight:'bold'}}>SYMBOLS:</label>
      <Stack direction="row" spacing={2}>
       
       <PushButton  onClick = { handleOnAdd} label =  {changeLanguageEnglish('stocks','addsymbols')}/>
       <PushButton  onClick = { ()=> {onSaveSymbols(newstockSymbols)}} label =  {changeLanguageEnglish('stocks','savesymbols')}/>

      </Stack>
    {Array.isArray(newstockSymbols) && newstockSymbols.map((stock, index) => (
    
      <Stack key = {index} direction="row" spacing={2} style={{marginTop:'6px', padding: '5px', backgroundColor: index === selectedSymbolsIndex ? 'lightblue': 'white'}} onClick={()=> {handleOnClick(index)}}>
       <>
       <Stack direction="row">
        <label style={{marginRight:'5px', fontSize:'16px', color:'maroon', fontWeight:'bold'}}>{index+1}.</label>
    
        <Delete className="promptIcon" style={{padding:'3px'}} onClick={()=>{handleDeleteSymbolsGroup(index)}} />
          <EditIcon className="editIcon"  style={{padding:'3px'}}onClick={()=> {onAddNewSymbols(index)}} />
        </Stack >
        <label>{stock.filter(s => s.trim()).join(', ') || 'None'}</label>
        </>
      </Stack>
    ))}

    </div> 

  );
};
